const mecId = (...args) => args.join('_');
export default mecId;
